module.exports = __webpack_public_path__ + "media/images/pic/brodno/team/teachers/martyna-stanczyk-bc8b4eede03e66ffde68cc97a567987d.png";